import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiEndpoint } from '../config/api';

const URL =
  process.env.REACT_APP_COMMANDS_API_URL ||
  apiEndpoint('api/commands.php');

const getToken = () =>
  sessionStorage.getItem('demo_auth_token') ||
  localStorage.getItem('demo_auth_token') ||
  '';

export default function CommandPrompt() {
  const navigate = useNavigate();

  /*
   * Chặn cùng một lệnh bị xử lý nhiều lần
   * do API đang được kiểm tra mỗi 3 giây.
   */
  const processingCommandId = useRef(null);

  useEffect(() => {
    let stopped = false;
    let timer = null;

    const acceptAndRedirect = async (command) => {
      if (
        !command?.id ||
        processingCommandId.current === command.id
      ) {
        return;
      }

      processingCommandId.current = command.id;

      try {
        const token = getToken();

        if (!token) {
          processingCommandId.current = null;
          return;
        }

        const response = await fetch(URL, {
          method: 'POST',

          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            id: command.id,
            status: 'accepted',
          }),
        });

        const data = await response.json().catch(() => null);

        if (!response.ok || data?.success === false) {
          throw new Error(
            data?.message ||
              'Không thể xác nhận lệnh.'
          );
        }

        if (stopped) {
          return;
        }

        /*
         * Nếu payload là đường dẫn thì dùng đường dẫn đó.
         * Không có payload thì mặc định chuyển tới /qrcode.
         */
        const destination =
          typeof command.payload === 'string' &&
          command.payload.startsWith('/')
            ? command.payload
            : '/qrcode';

        navigate(destination, {
          replace: true,
        });
      } catch (error) {
        console.error(
          'Không thể xử lý lệnh chuyển trang:',
          error
        );

        /*
         * Cho phép API kiểm tra lại lệnh trong lần tiếp theo.
         */
        processingCommandId.current = null;
      }
    };

    const checkCommand = async () => {
      const token = getToken();

      if (!token || stopped) {
        return;
      }

      try {
        const response = await fetch(URL, {
          method: 'GET',

          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },

          cache: 'no-store',
        });

        const data = await response.json();

        if (
          response.ok &&
          data.success &&
          data.command
        ) {
          await acceptAndRedirect(data.command);
        }
      } catch (error) {
        console.error(
          'Lỗi kiểm tra lệnh quản trị:',
          error
        );
      }
    };

    checkCommand();

    timer = window.setInterval(
      checkCommand,
      3000
    );

    return () => {
      stopped = true;

      if (timer) {
        window.clearInterval(timer);
      }
    };
  }, [navigate]);

  /*
   * Component chỉ chạy ngầm, không hiển thị popup.
   */
  return null;
}
